module.exports = __webpack_public_path__ + "2bfd4ef8af4e382102dbdfe495f73f52.pdf";